<template>
  <label :for="id">
    <div class="checkbox">
      <input
        type="checkbox"
        :id="id"
        tabindex="1"
        pad-up="go:#pad-onboarding-back"
        pad-a="click"
        @change="change"
      />
      <div></div>
    </div>
    <span>
      {{ label }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    change(e) {
      this.$emit("change", e.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    .checkbox > div {
      border-color: #7d7d7d;
    }
  }
}

.checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;

  width: 22px;
  height: 22px;
  margin-right: 10px;

  &:hover {
    & > div {
      background-image: url("~@/assets/img/svg/check.svg");
    }
  }
}

.checkbox input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

.checkbox > div {
  box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.1);
  background-color: rgba(0, 0, 0, 0.15);
  background-position: center center;
  background-repeat: no-repeat;
  flex-shrink: 0;
  position: relative;
  border: solid 1px rgb(65, 65, 66);

  width: 22px;
  min-width: 22px;
  flex: 0 0 22px;
  height: 22px;
  margin-right: 20px;
}

.checkbox input[type="checkbox"]:checked ~ div,
.checkbox--checked > div {
  background-image: url("~@/assets/img/svg/check.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-color: $green-darker;
  border-color: $green-darker;
  box-shadow: none;
}

.checkbox input[aria-invalid="true"] ~ div {
  border-color: $green-darker;
}
</style>
